import React, { useState, useEffect, useRef } from "react";
import "wp-styles.css";
import "App.scss";
import { Switch, Route, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AdminHome from "screens/AdminHome";
import Restaurant from "screens/Restaurant";
import Kiosk from "screens/Kiosk";
import ScreenSaver from "components/ScreenSaver/ScreenSaver";
import IdleTimer from "react-idle-timer";
import FoodCourt from "screens/FoodCourt/FoodCourt";
import useFetch from "hooks/useFetch";
import { mainApiPath } from "api/constants";
import * as actionTypes from "store/actions/actionTypes";
import { enableES5 } from "immer";
import {
  screenKeys,
  deviceFloorLevel,
  floorCode,
  screenSaverTime,
  initScreen,
} from "config/constants";
import ReactGA from "react-ga";

ReactGA.initialize(process.env.REACT_APP_GA_ID);

function App() {
  enableES5();

  document.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });

  const [error, loading, data] = useFetch(mainApiPath.store);
  const screenSaverTimeState = useSelector(
    (state) => state.settings.screenSaverTime
  );
  const [screenSaver, setScreenSaver] = useState(false);
  const timeout = 1000 * 6;
  const history = useHistory();
  const dispatch = useDispatch();
  const startScreenState = useSelector((state) => state.settings.startScreen);
  let delayActionTimerRef = useRef(null);

  useEffect(() => {
    if (data) {
      dispatch({ type: actionTypes.SET_LIST_OF_CODES, payload: data });
    }
  }, [data]);

  useEffect(() => {
    const localScreen = localStorage.getItem(initScreen);
    const localScreenSaver = localStorage.getItem(screenSaverTime);
    const localDeviceFloorLevel = localStorage.getItem(deviceFloorLevel);

    if (localScreen) {
      dispatch({ type: actionTypes.SET_START_SCREEN, payload: localScreen });
    }

    if (localScreenSaver) {
      dispatch({
        type: actionTypes.SET_SCREENSAVER_TIME,
        payload: localScreenSaver,
      });
    }

    if (localDeviceFloorLevel) {
      dispatch({
        type: actionTypes.SET_DEVICE_FLOOR_LEVEL,
        payload: floorCode[+localDeviceFloorLevel],
      });
    }
  }, []);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.altKey && event.keyCode === 77) {
        //Alt + M
        if (window.confirm("Go to config?")) {
          history.push("/config");
        } else {
          // Do nothing!
        }
      }
    };
    window.addEventListener("keydown", handleEsc);
    // window.addEventListener("click", e => playClickSpecial());
    return () => {
      window.removeEventListener("keydown", handleEsc);
      // window.removeEventListener("click", e => playClickSpecial());
    };
  }, []);

  const handleScreenSaverMode = (active) => {
    //FoodCourt not showing screen saver screen
    if (startScreenState === screenKeys.foodcourt) {
      if (active) { 
        dispatch({ type: actionTypes.CLEAR_ALL_FILTER });
        const curLocation =  history.location.pathname 
        if (curLocation !== '/' + screenKeys.foodcourt ) {
          history.push("/" + startScreenState);
        } 
      }
    } else {
      if (active) {
        dispatch({ type: actionTypes.SET_SCREENSAVER, payload: active });
        setScreenSaver(active);
      } else {
        if (delayActionTimerRef.current) {
          clearTimeout(delayActionTimerRef.current);
        }
        delayActionTimerRef.current = setTimeout(() => {
          setScreenSaver(active);
          delayActionTimerRef.current = null;
          dispatch({ type: actionTypes.SET_SCREENSAVER, payload: active });
          dispatch({ type: actionTypes.CLEAR_ALL_FILTER });
          history.push("/" + startScreenState);
        }, 500);
      }
    }
  };

  return (
    <>
      <Switch>
        <Route path={`/${screenKeys.foodcourt}`} component={FoodCourt} />
        <Route path={`/${screenKeys.kiosk}`} component={Kiosk} />
        <Route path={`/${screenKeys.restaurant}`} component={Restaurant} />
        <Route path={`/${screenKeys.config}`} component={AdminHome} />
        <Route path="/" component={AdminHome} />
      </Switch>
      {/* <IdleTimer
        timeout={timeout}
        onIdle={() => handleScreenSaverMode(true)}
        onActive={() => handleScreenSaverMode(false)}
      /> */}
      {/* <ScreenSaver on={screenSaver} /> */}
    </>
  );
}

export default App;
